export default {"src":"/_next/static/media/policy.d81f314c.svg","height":33,"width":32};